export const TolMessagesGetters = {
  HasMessages: 'TolMessagesGetters.HasMessages',
  Messages: 'TolMessagesGetters.Messages',
  KeepOnce: 'TolMessagesGetters.KeepOnce'
};

export const TolMessagesActions = {
  SetMessages: 'TolMessagesActions.SetMessages',
  ClearAll: 'TolMessagesActions.ClearAll',
  RemoveMessage: 'TolMessagesActions.RemoveMessage'
};

export const TolMessagesMutations = {
  SetMessages: 'TolMessagesMutations.SetMessages',
  ResetMessagesState: 'TolMessagesMutations.ResetMessagesState',
  RemoveMessage: 'TolMessagesMutation.RemoveMessage'
};
